import { observer } from 'mobx-react-lite';

import { Icons } from '@/assets/icons/icons';
import { XStack, YStack } from '@/components/ui';
import { cardFrame } from '@/features/action-cards-view/cardFrame';

import { HivemindGroupContent } from './hivemind-group-content';
import { useHivemindGroup } from './use-hivemind-group';

import type { ActionCard } from '@littlebird/sdk';
import type { ReactNode } from 'react';

/** A teammate message card in a chat. The cards of one outgoing message are one card, drawn at the first of them, and any other card is the children. */
export const HivemindChatCard = observer(function HivemindChatCard({
  card,
  children,
}: {
  readonly card: ActionCard;
  readonly children: ReactNode;
}) {
  const group = useHivemindGroup(card);
  if (!group) return children;
  if (!group.isFirst) return null;
  const PeopleIcon = group.rows.length > 1 ? Icons.users : Icons.user;
  return (
    <YStack className={`${cardFrame('web_chat')} gap-3`}>
      <XStack className="items-center gap-2 text-sm font-medium text-foreground">
        <PeopleIcon className="size-4 text-foreground-muted" />
        {group.title}
      </XStack>
      <HivemindGroupContent group={group} clampAnswers={false} />
    </YStack>
  );
});
